/*
openbikebox Frontend
Copyright (C) 2021 binary butterfly GmbH

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU General Public License for more details.

You should have received a copy of the GNU General Public License
along with this program.  If not, see <http://www.gnu.org/licenses/>.
*/

export const requestGet = async (url) => {
    const response = await fetch(url, {
        method: 'GET',
    });
    return await response.json();
};

export const requestJsonPost = async (url, data, csrf_token) => {
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...(csrf_token && {'X-CSRFToken': csrf_token}),
        },
        body: JSON.stringify(data),
    });
    return response.json();
};

export const requestAdminAjaxPost = async (url, action, data) => {
    let form_data = new FormData();
    form_data.append('action', action);
    form_data.append('data', JSON.stringify(data));
    const response = await fetch(url, {
        method: 'POST',
        body: form_data,
    });
    if (response.status === 204) {
        return null;
    }
    return response.json();
};

export const transformAttribute = (attribute) => {
    let result = '';
    let counter = 0;
    while (counter < attribute.length) {
        if (attribute[counter] === '-' && counter < attribute.length + 1) {
            result += attribute[counter + 1].toUpperCase();
            counter += 2;
            continue;
        }
        if (attribute[counter] === '-') {
            break;
        }
        result += attribute[counter];
        counter++;
    }
    return result;
};


export const formatDate = (date) => {
    const date_str = date.toISOString();
    return date_str.substring(8, 10) + '.' + date_str.substring(5, 7) + '.' + date_str.substring(0, 4);
}

export const ComponentStatus = {
    loading: 1,
    ready: 2,
    error: 3,
    accessDenied: 4,
};


export const isValidEmail = (email) => {
    return email.toLowerCase().match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    ) !== null;
}
